<template>
    <div class="content-container">
        <div style="height: 60px;display: flex; align-items: center; justify-content: center; margin-bottom: 40px " class="">



            <img :src="logo" alt="logo" style="height: 50px" />




        </div>

        <div v-if="$store.getters.accountTypeId !== 4" style="display: flex; flex-direction: column; flex: 1">
            <div style="flex: 1" >
                <div class="app-sub-header pl-4 mb-4" style="color: #6ab6d0">
                    Main Menu
                </div>


                <router-link
                    :to="route.route"
                    v-for="route in routesTop"
                    :key="route.route"
                    class="sidebar-link"
                >

                    {{ route.label }}

                </router-link>
            </div>
            <div>
                <router-link
                    :to="route.route"
                    v-for="route in routesBottom"
                    :key="route.route"
                    class="sidebar-link"
                >

                    <!--                <div style="padding-right: 10px" >-->
                    <!--                    <v-icon class="icon">{{route.icon}}</v-icon>-->
                    <!--                </div>-->
                    {{ route.label }}
                </router-link>
<!--                <router-link -->
<!--                    to="https://help.swaymedical.com"-->
<!--                    class="sidebar-link">-->
<!--                    Help-->
<!--                </router-link>-->
                <a class="sidebar-link" target="_blank" href="https://help.swaymedical.com">
                    Help
                </a>
            </div>
        </div>
        <div v-else>
            <router-link
                v-for="route in covidUserRoutes"
                :to="route.route"
                :key="route.route"
                class="sidebar-link"
            >
                {{ route.label }}
            </router-link>
        </div>

    </div>
</template>

<script>
import swayLogo from "@/assets/images/sway-logo-white-v2.png";
import {
    mdiAccountGroup, mdiAccountOutline,
    mdiCardAccountDetailsOutline, mdiClipboardAccountOutline,
    mdiClipboardCheckMultipleOutline,
    mdiClipboardTextOutline, mdiCogOutline, mdiDeathlyHallows,
    mdiSpeedometer, mdiViewDashboard
} from "@mdi/js";
import {superAdminSymbol} from "@/js/shared/constants";
import {getOrganizationPreferences} from "@/services/organization.service";

export default {
    name: "SidebarLeft",
    props: {
        company: {
            type: String
        },
    },
    data() {
        return {
            user: null,
            logo: swayLogo,
            routes: [],
	        superAdminSymbol,
            orgPreferences: null,
            // routes: [
            //     {
            //         label: 'Dashboard',
            //         route: '/dashboard',
            //         icon: mdiSpeedometer
            //     },
            //     {
            //         label: 'Profiles',
            //         route: '/profiles',
            //         icon: mdiCardAccountDetailsOutline
            //     },
            //
            //     {
            //         label: 'Groups',
            //         route: '/groups',
            //         icon: mdiAccountGroup
            //     },
            //     {
            //         label: 'Protocols',
            //         route: '/protocols',
            //         icon: mdiClipboardCheckMultipleOutline
            //     },
            //     {
            //         label: 'Codes',
            //         route: '/codes',
            //         icon: mdiClipboardTextOutline
            //     },
            //     {
            //         label: 'Tools',
            //         route: '/tools',
            //         icon: mdiClipboardAccountOutline
            //     }
            // ],
            covidUserRoutes: [
                {
                    label: 'Account',
                    route: '/account',
                    icon: mdiAccountOutline,
                }
            ]

        }
    },
    created() {
        this.logo = swayLogo;
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
                        
            if (this.$store.getters.isOrgAdmin || this.$store.getters.viewingAsSuper) {
                this.routes.push({
                        label: 'Users',
                        route: '/users',
                        icon: mdiClipboardAccountOutline
                    },

                )
            }

        }
    },
    computed: {
        routesTop(){
            
            let items = [];
            
            if (this.$store.getters.isEnterpriseAdminOrg){
                items = [
                    {
                        label: 'Dashboard',
                        route: '/dashboard',
                        icon: mdiSpeedometer
                    },
                    //{
                    //    label: 'Protocols',
                    //    route: '/protocols',
                    //    icon: mdiClipboardCheckMultipleOutline
                    //},
                    {
                        label: 'Tools',
                        route: '/tools',
                        icon: mdiClipboardAccountOutline
                    }
                ];				
            }
            else
            {
                items = [
                    {
                        label: 'Dashboard',
                        route: '/dashboard',
                        icon: mdiSpeedometer
                    },
                    {
                        label: 'Profiles',
                        route: '/profiles',
                        icon: mdiCardAccountDetailsOutline
                    },

                    {
                        label: 'Groups',
                        route: '/groups',
                        icon: mdiAccountGroup
                    },
                    {
                        label: 'Protocols',
                        route: '/protocols',
                        icon: mdiClipboardCheckMultipleOutline
                    },
                    {
                        label: 'Codes',
                        route: '/codes',
                        icon: mdiClipboardTextOutline
                    },
                    {
                        label: 'Tools',
                        route: '/tools',
                        icon: mdiClipboardAccountOutline
                    }
                ];
            }

            if (this.$store.getters.isOrgAdmin || this.$store.getters.viewingAsSuper) {
                items.push({
                        label: 'Users',
                        route: '/users',
                        icon: mdiClipboardAccountOutline
                    },
                )
            }

            if (this.$store.getters.isOrgAdmin || this.$store.getters.viewingAsSuper || this.$store.getters.isBillingContact) {
                items.push({
                        label: `Reporting`,
                        route: '/test-volume-report',
                        icon: mdiClipboardAccountOutline
                    },
                )
            }
            
            return items;
        },
        routesBottom() {
            let items = [];

            if (!this.$store.getters.viewingAsSuper) {
                items.push({
                    label: 'Account',
                    route: '/account',
                    icon: mdiAccountOutline,

                })
            }

            

            if (this.$store.getters.isOrgAdmin || this.$store.getters.isSuperAdmin) {
                items.push({
                    label: 'Organization',
                    route: '/organization',
                    icon: mdiCogOutline
                });
            }

            if (this.$store.getters.isOrgAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isBillingContact) {
                items.push({
                    label: 'Billing',
                    route: '/billing',
                    icon: mdiCogOutline
                });
            }
	
	        if (this.$store.getters.isSuperAdmin) {
		        items.push({
				        label: `${superAdminSymbol} Org Management`,
				        route: '/org-management',
				        icon: mdiDeathlyHallows,
			        }
		        )
	        }

            if (this.$store.getters.isSuperAdmin || this.$store.getters.viewingAsSuper) {
                items.push({
                    label: `${superAdminSymbol} Internal Sway Admin`,
                    route: '/super-admin',
                    icon: mdiDeathlyHallows
                })
            }
            return items
        }
    }
}
</script>

<style scoped>
.app-sub-header {
    text-transform: uppercase;
    color: #66E0FF;
    font-weight: 600;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
    font-family: 'Inter', sans-serif;
}

.content-container {
    display: flex;
    flex: 1;
    height: 100%;
    background-color: #1F2937;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
    border-right: none;
}

.sidebar-link {
    text-decoration: none;
    display: flex;
    flex: 1;
    max-height: 44px;
    align-items: center;
    padding: 12px 20px;
    margin: 2px 8px;
    font-size: 0.9375rem;
    font-weight: 500;
    font-family: 'Inter', sans-serif;
    color: #9CA3AF;
    border-radius: 8px;
    transition: all 0.15s ease;
}

.sidebar-link:hover {
    background-color: #374151;
    color: #F9FAFB;
}

a {
    text-decoration: none;
}

.router-link-active {
    background-color: #33D3FF !important;
    color: white !important;
    font-weight: 600;
    border-right: none;
}

.router-link-active:hover {
    background-color: #00B8E6 !important;
}

.router-link-active > div {
    text-decoration: none;
}

.router-link-active > div > .v-icon {
    color: white;
}

.v-icon.v-icon {
    color: #9CA3AF;
}

</style>